import { Stack, Typography } from '@mui/material';
import { CountryCode } from 'libphonenumber-js';
import { FC } from 'react';
import { CountryOptionType } from './types';

const getFlagImageSrc = (isoCode: CountryCode) => {
    return `https://flagcdn.com/w40/${isoCode.toLowerCase()}.webp`;
};

type CountryOptionProps = CountryOptionType & {
    withTextLabel?: boolean;
};

export const CountryOption: FC<CountryOptionProps> = ({ name, code, dialCode, withTextLabel = true }) => {
    return (
        <Stack spacing={1} direction="row" alignItems="center">
            <img src={getFlagImageSrc(code)} loading="lazy" width="24" height="18" alt={name} />
            {withTextLabel && (
                <Typography>
                    {dialCode} {name}
                </Typography>
            )}
        </Stack>
    );
};
